import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7 7l5 5l-5 5","key":"svg-0"}],["path",{"d":"M13 7l5 5l-5 5","key":"svg-1"}]]

/**
 * IconChevronsRight
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItY2hldnJvbnMtcmlnaHQiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTcgN2w1IDVsLTUgNSIgLz4KICA8cGF0aCBkPSJNMTMgN2w1IDVsLTUgNSIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/chevrons-right
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconChevronsRight = createReactComponent('outline', 'chevrons-right', 'ChevronsRight', __iconNode);

export default IconChevronsRight;